import { render, staticRenderFns } from "./r-item-recipe-dialog.vue?vue&type=template&id=7d4506aa&scoped=true"
import script from "./r-item-recipe-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-recipe-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-recipe-dialog.vue?vue&type=style&index=0&id=7d4506aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4506aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d4506aa')) {
      api.createRecord('7d4506aa', component.options)
    } else {
      api.reload('7d4506aa', component.options)
    }
    module.hot.accept("./r-item-recipe-dialog.vue?vue&type=template&id=7d4506aa&scoped=true", function () {
      api.rerender('7d4506aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-recipe/r-item-recipe-dialog.vue"
export default component.exports